import { Tooltip } from './Tooltip';
var Chart = {
    Tooltip: Tooltip,
};
export default Chart;
//# sourceMappingURL=index.js.map